<template>
  <div class="modal confirmation-modal">
    <div class="confirmation-modal__panel">
      <div class="modal__main-icon modal__main-icon--delete-user"></div>
      <div class="confirmation-modal__body">
        <span v-if="deleteModal.type === 'separate'">
          {{ $t(`deleteModal.${"separateQuestion"}`) }} {{ deleteModal.message }}?
        </span>
        <span v-else>
          {{ $t(`deleteModal.${"question"}`) }}
          <span v-if="route.name === 'Customers'">{{ $t(`deleteModal.${"customer"}`) }} </span>
          <span v-if="route.name === 'Users'">{{ $t(`deleteModal.${"agent"}`) }} </span>
          <span v-if="route.name === 'Reports'">{{ $t(`deleteModal.${"report"}`) }} </span>
          <span v-if="route.name === 'UserRights'">{{ $t(`deleteModal.${"role"}`) }} </span>
          <span>{{ deleteModal.message }}?</span>
        </span>
      </div>
      <div class="confirmation-modal__footer">
        <button type="button" class="confirmation-modal__button confirmation-modal__button--cancel"
          @click="cancelDelete">
          {{ $t(`deleteModal.${"cancel"}`) }}
        </button>
        <button v-if="deleteModal.type === 'separate'" type="button" class="confirmation-modal__button confirmation-modal__button--delete"
          @click="deleteEntity()">
          {{ $t(`deleteModal.${"separate"}`) }}
        </button>
        <button v-else type="button" class="confirmation-modal__button confirmation-modal__button--delete"
          @click="deleteEntity()">
          {{ $t(`deleteModal.${"delete"}`) }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

defineOptions({
  name: "DeleteModal",
});

const store = useStore();
const route = useRoute();

// Computed property replacing mapGetters
const deleteModal = computed(() => store.getters.deleteModal);

// Methods
const cancelDelete = () => {
  store.commit("setDeleteModal", {
    display: false,
    message: "",
    type: null,
  });
};

const deleteEntity = () => {
  if (Array.isArray(deleteModal.value.action)) {
    deleteModal.value.action[0](deleteModal.value.id);
  } else {
    deleteModal.value.action(deleteModal.value.id);
  }

  store.commit("setDeleteModal", {
    display: false,
    message: "",
    action: null,
    id: null,
    type: null,
  });
};
</script>

<style scoped lang="scss">
.delete {
  &__body {
    font-size: var(--x-smaller);
    text-align: center;
    color: var(--text-2);
    font-size: var(--medium);
    font-family: var(--muli-text-semi-bold);
    line-height: 33px;
    margin: 50px 0 45px 0;
  }

  &__footer {
    display: flex;
    justify-content: center;
  }

  &__button {
    height: 40px;
    width: 135px;
    margin-right: 30px;
    color: var(--text-1);
    border-radius: var(--radius-1);
    font-size: var(--medium);
    background: var(--bg-18);
    box-shadow: 0px 7px 18px var(--shadow-11);
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0px 0px 20px var(--shadow-11);
      background: var(--hover-3);
    }

    &--submit {
      background: var(--bg-26);
      box-shadow: 0px 7px 18px var(--shadow-8);
      margin: 0 0 0 30px;

      &:hover {
        box-shadow: 0px 0px 20px var(--shadow-8);
        background: var(--hover-4);
      }
    }
  }
}
</style>
